import { Moon, Sun } from "lucide-react";

import { useTheme } from "@/components/theme-provider-context";
import { Button } from "@/components/ui/v2/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/v2/dropdown-menu";
import { getTheme, isBaseTheme, THEMES } from "@/themes/registry";

export function ModeToggle() {
  const { theme, setTheme } = useTheme();
  const activeTheme = getTheme(theme);
  const ActiveIcon = activeTheme.icon;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="relative">
          {isBaseTheme(activeTheme) ? (
            <>
              <Sun className="h-[1.2rem] w-[1.2rem] scale-100 rotate-0 transition-all dark:scale-0 dark:-rotate-90" />
              <Moon className="absolute h-[1.2rem] w-[1.2rem] scale-0 rotate-90 transition-all dark:scale-100 dark:rotate-0" />
            </>
          ) : (
            <ActiveIcon className="h-[1.2rem] w-[1.2rem]" />
          )}
          <span className="sr-only">Toggle theme</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {THEMES.map(({ id, label, icon: Icon }) => (
          <DropdownMenuItem key={id} onClick={() => setTheme(id)}>
            <Icon />
            {label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
